import "../lib/bootstrap-css";
import ProductsNav from "./products-nav";

export default function ProductNav() {
	return <ProductsNav locale="en" />;
}
